export const translationsKa = {
    search: "ძიება",
    categories: "კატეგორიები",
    findBlog: "მოძებნე ბლოგი",
    day: "დღის",
    week: "კვირის",
    month: "თვის",
    notValid: "შევსებული ინფორმაცია არავალიდურია",
    fillFields: "გასაგრძელებლად შეავსე ყველა აუცილებელი ველი",
    oldPassword: "ძველი პაროლი",
    optional: "არასავალდებულო",
    or: "ან",
    password: "პაროლი",
    passwordCharacters: "პაროლი უნდა შეიცავდეს მინიმუმ 8 სიმბოლოს",
    passwordInvalid:"გამოიყენე მხოლოდ სიმბოლოები, რიცხვები და ლათინური ასოები",
    passwordLink1: "პაროლის აღსადგენად, შეიყვანე რეგისტრირებული მეილი",
    passwordLink2: "პაროლის აღდგენის ბმული გამოგზავნილია მეილზე",
    passwordLink3: "შეამოწმე მეილი, მიჰყევი აღდგენის ბმულს და განაახლე პაროლი.თუ ასეთ მეილს ვერ იპოვი, შეამოწმე SPAM საქაღალდე.",
    passwordMinimumLength: "პაროლი უნდა შეიცავდეს მინიმუმ 8 სიმბოლოს",
    passwordNotMatch:  "პაროლები არ ემთხვევა",
    passwordRemember: "პაროლის დამახსოვრება",
    passwordRequired: "გთხოვ, შეავსო პაროლის ველი",
    passwordUpdated: "პაროლი განახლებულია",
    edit: "შეცვლა",
    email: "მეილი",
    emailNotValid: "შეყვანილი მეილი არავალიდურია",
    emailRequired: "გთხოვ, შეავსო მეილის ველი",
    fullNameRequired: "გთხოვ, შეავსო სახელი და გვარი",
    fullNameCharacters1:"სახელი, გვარი უნდა შედგებოდეს მინიმუმ 2 ასოსგან",
    fullNameCharacters2:"სახელი, გვარი უნდა მოიცავდეს მაქსიმუმ 30 სიმბოლოს",
    fullNameInvalidCharacters: "ჩაწერე მხოლოდ სიმბოლოები, ქართული და ინგლისური ასოები ",
    repeatPasswordRequired: "გაიმეორე პაროლი",
    phone: "მობილურის ნომერი",
    phoneCharacters: "მობილურის ნომერი უნდა შეიცავდეს მინიმუმ 9 ციფრს",
    phoneCharacters2:"მობილურის ნომერი უნდა შეიცავდეს მაქსიმუმ 13 ციფრს",
    phoneRequired: "გთხოვ, ჩაწერო მობილურის ნომერი",
    back: "უკან",
    updateYourPassword: "პაროლის აღდგენა",
    sendAgain: "ხელახლა გაგზავნა",
    sendMeLink: "გაგზავნა",
    cantGetMail: "მეილი არ მოვიდა?",
    facebookAuth: "შესვლა Facebook-ით",
    googleAuth: "შესვლა Google-ით",

  };